import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const TermsPage: React.FC = () => {
  const content = `🧾 Allgemeine Geschäftsbedingungen (AGB)
für die Nutzung der Plattform Sistasouk.de

§ 1 Anbieter und Geltungsbereich
(1) Die Internetplattform Sistasouk.de wird betrieben von
[Dein Name / Betreiberin von Sistasouk.de]
(E-Mail: [deine@adresse.de])
– im Folgenden „Betreiberin“ genannt.
(2) Diese AGB regeln die Nutzung der Plattform Sistasouk.de durch registrierte Nutzerinnen („Mitglieder“). Mit der Registrierung auf Sistasouk.de erkennt jede Nutzerin diese AGB als verbindlich an.
(3) Die Plattform richtet sich ausschließlich an weibliche Privatpersonen mit Wohnsitz in Deutschland, Österreich oder der Schweiz. Gewerbliche Verkäuferinnen sind nicht zugelassen.

§ 2 Leistungsbeschreibung
(1) Sistasouk.de stellt eine Online-Community bereit, über die registrierte Nutzerinnen private Artikel (insbesondere Kleidung, Accessoires, Haushaltswaren, Elektro-Kleingeräte, Babyartikel u. a.) anbieten und erwerben können.
(2) Die Betreiberin stellt nur die technische Plattform zur Verfügung.
Sie ist weder Verkäuferin, Käuferin, Vermittlerin noch Eigentümerin der auf Sistasouk.de angebotenen Artikel.
(3) Der Kaufvertrag kommt ausschließlich zwischen den jeweiligen Nutzerinnen zustande.
(4) Aktuell ist die Nutzung der Plattform kostenlos.
Die Betreiberin behält sich vor, künftig eine Gebühr von 0,70 € pro erfolgreich vermitteltem Verkauf zu berechnen. Hierüber werden alle Nutzerinnen rechtzeitig vor Einführung informiert.

§ 3 Registrierung und Teilnahmebedingungen
(1) Die Registrierung ist nur Frauen ab 18 Jahren erlaubt.
(2) Die Betreiberin entscheidet nach eigenem Ermessen, wer Zugang zur Plattform erhält. Ein Anspruch auf Zulassung besteht nicht.
(3) Nutzerinnen verpflichten sich, bei der Registrierung wahrheitsgemäße Angaben zu machen und ihre Daten aktuell zu halten.

§ 4 Verhalten auf der Plattform
(1) Auf Sistasouk.de gilt ein respektvoller und gesitteter Umgangston.
Beleidigungen, Drohungen, Diskriminierungen oder Belästigungen werden nicht geduldet.
(2) Es ist verboten, Inhalte oder Artikel einzustellen, die
gegen Gesetze oder Rechte Dritter verstoßen,
urheberrechtlich geschützte Materialien ohne Berechtigung verwenden,
gestohlene oder verbotene Waren enthalten,
sexuell anstößig, gewaltverherrlichend oder diskriminierend sind.
(3) Nutzerinnen dürfen keine betrügerischen Handlungen vornehmen oder falsche Angaben zu Artikeln machen.
(4) Jede Nutzerin ist für die von ihr eingestellten Inhalte, Fotos und Beschreibungen allein verantwortlich.

§ 5 Zahlungsabwicklung
(1) Zahlungen zwischen Nutzerinnen erfolgen direkt und ausschließlich über PayPal oder andere zukünftig freigegebene Dienste.
(2) Die Betreiberin ist nicht an den Zahlungen beteiligt, verwaltet keine Gelder und haftet nicht für Zahlungsstörungen oder Streitigkeiten.

§ 6 Bewertungen, Kommentare und Chat
(1) Mitglieder dürfen Bewertungen, Kommentare und Chatnachrichten austauschen, solange diese sachlich, respektvoll und wahrheitsgemäß sind.
(2) Die Betreiberin behält sich vor, Beiträge zu löschen, die gegen diese AGB oder geltendes Recht verstoßen.

§ 7 Haftung und Verantwortlichkeit
(1) Die Betreiberin übernimmt keine Haftung für:
die Richtigkeit der von Nutzerinnen gemachten Angaben,
die Qualität, Beschaffenheit oder Lieferung der Artikel,
Schäden, die durch Kaufverträge zwischen Nutzerinnen entstehen.
(2) Die Betreiberin haftet nur für Schäden, die auf vorsätzliche oder grob fahrlässige Pflichtverletzungen ihrerseits zurückzuführen sind.
(3) Die Plattform kann zeitweise wegen Wartungsarbeiten oder technischer Probleme nicht erreichbar sein; hieraus entsteht kein Anspruch auf Schadensersatz.

§ 8 Urheberrecht
Alle Inhalte und Strukturen der Plattform sind urheberrechtlich geschützt. Eine Nutzung außerhalb der Plattform bedarf der Zustimmung der Betreiberin.

§ 9 Widerruf, Rückgabe und Garantie
(1) Da alle Verkäufe zwischen Privatpersonen erfolgen, besteht kein Widerrufs- oder Rückgaberecht im Sinne des Verbraucherschutzgesetzes.
(2) Eine Gewährleistung oder Garantie durch die Betreiberin wird ausdrücklich ausgeschlossen.

§ 10 Kündigung und Ausschluss
(1) Nutzerinnen können ihre Mitgliedschaft jederzeit selbst beenden.
(2) Die Betreiberin kann Nutzerinnen ausschließen, die gegen diese AGB oder geltendes Recht verstoßen.

§ 11 Datenschutz
Der Schutz personenbezogener Daten richtet sich nach der Datenschutzerklärung von Sistasouk.de, abrufbar unter https://sistasouk.de/datenschutz.

§ 12 Schlussbestimmungen
(1) Es gilt deutsches Recht.
(2) Gerichtsstand ist der Sitz der Betreiberin, soweit gesetzlich zulässig.
(3) Sollte eine Bestimmung dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.`;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography component="div" sx={{ whiteSpace: 'pre-wrap', fontSize: '1rem', lineHeight: 1.75 }}>
          {content}
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsPage;
